import useSources from "~/ui-rtk/hooks/sources"

const content = {
  id: "mentions-analysis-page",
  slug: "/brand-research/mentions-analysis",
  icon: null,
  title: "Mentions Analysis",
  parent: {
    slug: "/brand-research",
    title: "Brand Research",
  },
  metadata: {
    visibleToRoles: ["SUPER_ADMIN", "ADMIN", "USER"],
  },
  order: 30.1,
}

export default function useConnect() {
  const { isLoading: isSourcesDataLoading } = useSources()

  return {
    content,
    isLoading: isSourcesDataLoading,
  }
}
